if (!customElements.get('pdp-hero-banner')) {
  class PDPHeroBanner extends HTMLElement {
    constructor() {
      super();
      this.desktopVideo = this.querySelector('.js-pdp-hero-video-desktop');
      this.mobileVideo = this.querySelector('.js-pdp-hero-video-mobile');
      this.mq = window.matchMedia('(max-width: 989px)');
      this.init();
    }
  
    init() {
      if (!this.desktopVideo && !this.mobileVideo) return;
      this.resizeHandler(this.mq);
      this.mq.addListener(this.resizeHandler.bind(this));
    }

    resizeHandler(mq) {
      if (mq.matches) {
        this.pauseVideo('desktop');
        this.playVideo('mobile');
      } else {
        this.pauseVideo('mobile');
        this.playVideo('desktop');
      }
    }

    pauseVideo(breakpoint) {
      if (breakpoint === 'desktop' && this.desktopVideo) {
        this.desktopVideo.pause();
      }

      if (breakpoint === 'mobile' && this.mobileVideo) {
        this.mobileVideo.pause();
      }
    }

    playVideo(breakpoint) {
      if (breakpoint === 'desktop' && this.desktopVideo) {
        this.desktopVideo.play();
      }

      if (breakpoint === 'mobile' && this.mobileVideo) {
        this.mobileVideo.play();
      }
    }
  }
  
  customElements.define('pdp-hero-banner', PDPHeroBanner);
}
